import i18next from 'i18next'
import toast from 'react-hot-toast'
import { httpLogout } from '@/features/auth/http/auth.http'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { queryClient } from '@/query-client'

export const logout = async () => {
	try {
		await httpLogout()
		useAuthStore.getState().reset()
		queryClient.clear()
	} catch (_e) {
		toast.error(i18next.t('errors:default'))
	}
}
